export default __webpack_public_path__ + "static/02-8183de5225078dbbcd9c1f11b65f3588.png";